import { forwardRef } from 'react';
import { Button } from '@mui/material';
import { IOutlinedButton } from 'types/atoms';

const COutlinedButton = forwardRef<HTMLButtonElement, IOutlinedButton>((props, ref) => {
  return (
    <Button
      {...props}
      ref={ref}
      variant="outlined"
      classes={{
        root: 'rounded-xl border-2 border-secondary-800 px-[14px] py-1 text-label16 normal-case text-secondary-800 hover:border-2 hover:border-secondary-900 hover:bg-secondary-0  hover:text-secondary-900 disabled:border-neutral-200',
        startIcon: 'mx-0 [&>*:nth-of-type(1)]:text-xl',
        endIcon: 'mx-0 [&>*:nth-of-type(1)]:text-xl',
        outlinedSizeSmall: '',
        outlinedSizeMedium: 'h-[44px]',
        outlinedSizeLarge: 'h-[52px]',
      }}
    />
  );
});

export default COutlinedButton;
